
import React from 'react';
import styled, { keyframes } from 'styled-components';
import CountUp from 'react-countup';
import { FaBrain, FaMobileAlt, FaUsers, FaCommentDots } from 'react-icons/fa';

const stats = [
  { icon: FaBrain, end: 45, suffix: '%', text: 'of U.S. youth aged 15-24 experience mental health challenges' },
  { icon: FaMobileAlt, end: 7, prefix: '+', text: 'hours daily screen time contributing to stress and overload' },
  { icon: FaUsers, end: 50, suffix: '%', text: 'increase in social isolation among teens' },
  { icon: FaCommentDots, end: 73, suffix: '%', text: 'prefer stigma-free AI mental health conversations initially' },
];

const CrisisOverview = () => {
  return (
    <OverviewSection id="overview">
      <Container>
        <SectionHeading>The Youth Mental Health Crisis</SectionHeading>
        <StatsGrid>
          {stats.map((stat, index) => (
            <StatCard key={index}>
              <IconWrapper>{React.createElement(stat.icon)}</IconWrapper>
              <StatNumber>
                <CountUp end={stat.end} prefix={stat.prefix} suffix={stat.suffix} duration={4} enableScrollSpy scrollSpyDelay={300} />
              </StatNumber>
              <StatText>{stat.text}</StatText>
            </StatCard>
          ))}
        </StatsGrid>
        <KeyDrivers>
          Key drivers include stress, digital overuse, social isolation, and barriers to help-seeking.
        </KeyDrivers>
      </Container>
    </OverviewSection>
  );
};

export default CrisisOverview;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const OverviewSection = styled.section`
  background-color: var(--background-dark);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const SectionHeading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 4rem;
  color: var(--primary-blue-dark);

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
`;

const StatCard = styled.div`
  background: var(--background-light);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  animation: ${fadeIn} 0.5s ease-out forwards;
  opacity: 0;

  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
`;

const IconWrapper = styled.div`
  font-size: 3rem;
  color: var(--primary-blue-light);
  margin-bottom: 1rem;
`;

const StatNumber = styled.div`
  font-size: 3.5rem;
  font-weight: 700;
  color: var(--primary-blue-dark);
`;

const StatText = styled.p`
  font-size: 1rem;
  color: var(--text-dark);
  margin-top: 0.5rem;
`;

const KeyDrivers = styled.p`
  font-size: 1.2rem;
  font-style: italic;
  color: var(--text-dark);
  opacity: 0.8;
`;
